import React, { useState } from 'react'
import { Card, Col, Space, Table, theme, Button, Tooltip, Popconfirm } from 'antd'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronLeft, faArrowUp, faAllergies, faPills, faTimes, faCheck } from '@fortawesome/free-solid-svg-icons'
import CustomRow from '../../../../reusable-components/CustomRow'
import { hexToRGBA } from '../../../../lib/utils'
import FeatureButton from '../../../../reusable-components/FeatureButton'
import CustomButton from '../../../../reusable-components/CustomButton'
import PatientInfoMedHist from '../../../../Bookings/components/PatientInfoMedHist'
import NurseScreeningMedicalHistory from '../../../../Bookings/components/Examination Components/MedicalHistoryView'
import { formatMedicationName } from '../../../utils/lib'

const SidePanel = ({
  patientChronicDetails,
  setShowClipboard,
  setDischemModalOpen,
  handleCancel,
  handleCreateScript,
  handleSave,
  scriptBusy,
  loading,
  printingScript,
  saving,
  script,
  isNew,
  isCopy,
  isEditMode,
  dischemDeliveryApplicable,
  selectedDischem,
  dischemType,
  dischemPaymentType,
  userRef
}) => {
  const [showChronic, setShowChronic] = useState(false)
  const [showAllergies, setShowAllergies] = useState(false)
  const { token } = theme.useToken()

  // Common button style for consistency
  const buttonStyle = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxShadow: 'none',
    height: '40px',
    width: '100%',
    marginBottom: '8px'
  }

  if (showChronic || showAllergies) {
    return (
      <Card
        bodyStyle={{ padding: 0 }}
        headStyle={{ background: hexToRGBA(showChronic ? '#F39C12' : '#FF6A88', 0.2) }}
        size='small'
        title={
          <>
            <FontAwesomeIcon
              style={{ cursor: 'pointer' }}
              icon={faChevronLeft}
              onClick={() => {
                setShowChronic(false)
                setShowAllergies(false)
              }}
            />{' '}
            {showChronic ? ' Chronic Details' : showAllergies ? 'Allergies' : 'Dischem Delivery/Collection'}
          </>
        }
      >
        {showAllergies ? (
          <>
            {patientChronicDetails?.allergies?.medsList?.length > 0 ? (
              <Table
                size='small'
                pagination={false}
                style={{ marginTop: 1 }}
                showHeader={false}
                dataSource={patientChronicDetails?.allergies?.medsList}
                columns={[{ render: (entry) => entry }]}
              />
            ) : (
              <CustomRow style={{ padding: 12, minHeight: 200 }}>
                <Col span={24}>
                  <center>No recorded allergies to date.</center>
                </Col>
              </CustomRow>
            )}
          </>
        ) : undefined}

        {showChronic ? (
          <>
            {patientChronicDetails ? (
              <>
                <Table
                  style={{ marginTop: 1 }}
                  showHeader={false}
                  size='small'
                  dataSource={patientChronicDetails?.chronicIllnesses?.list}
                  pagination={false}
                  columns={[
                    {
                      title: 'Chronic Illness',
                      render: (record) => `${record.description} - ${record.code}`
                    }
                  ]}
                  expandable={{
                    defaultExpandAllRows: false,
                    expandedRowRender: (record) => (
                      <Table
                        size='small'
                        style={{ borderRadius: 0, borderBottom: 0 }}
                        headStyle={{ borderRadius: 0 }}
                        pagination={false}
                        dataSource={record.medications.map((med) => ({
                          ...med.med,
                          isChronic: true,
                          icd: {
                            code: record.code,
                            description: record.description
                          }
                        }))}
                        columns={[
                          {
                            title: 'Medication',
                            render: (med) => (
                              <>{`${formatMedicationName(med.name || '')} ${
                                med.strengthMetric1 ? med.strengthMetric1 : ''
                              } ${med.unitOfMeasure1 ? med.unitOfMeasure1 : ''} ${
                                med.presentationCode ? med.presentationCode : ''
                              } - ${med.standardPacksize ? med.standardPacksize : ''}`}</>
                            )
                          }
                        ]}
                      />
                    ),
                    rowExpandable: (record) => record?.medications?.length > 0
                  }}
                  rowKey={(record, index) => index}
                />
                <div style={{ height: 78, display: 'flex', justifyContent: 'space-between' }}>
                  <small style={{ marginTop: 4, marginLeft: 20 }}>
                    <FontAwesomeIcon icon={faArrowUp} /> Click to expand / collapse
                  </small>
                </div>
              </>
            ) : (
              <CustomRow style={{ padding: 12, minHeight: 200 }}>
                <Col span={24}>
                  <center>No record chronic illnesses to date.</center>
                </Col>
              </CustomRow>
            )}
          </>
        ) : undefined}
      </Card>
    )
  }

  return (
    <Space wrap direction='vertical' style={{ maxWidth: 500, minWidth: 250, position: 'relative', zIndex: 10 }}>
      {/* Script Control Buttons */}
      <div
        style={{
          width: '100%',
          display: 'flex',
          justifyContent: 'space-between',
          gap: '16px',
          marginBottom: '40px',
          position: 'relative',
          zIndex: 10
        }}
      >
        {isNew || isCopy ? (
          <Popconfirm
            title='Confirm Cancel'
            description='Are you sure? All progress will be lost.'
            onConfirm={() => {
              if (handleCancel) {
                handleCancel()
              }
            }}
            okText='Yes'
            cancelText='No'
            okButtonProps={{
              style: { background: token.colorError },
              danger: true
            }}
            disabled={scriptBusy || loading || printingScript}
          >
            <Button
              style={{
                ...buttonStyle,
                background: '#fff2f0',
                borderColor: '#ffccc7',
                color: '#ff4d4f',
                width: '50%',
                marginBottom: 0
              }}
              icon={<FontAwesomeIcon icon={faTimes} style={{ marginRight: 8 }} />}
              disabled={scriptBusy || loading || printingScript}
            >
              Close
            </Button>
          </Popconfirm>
        ) : (
          <Button
            style={{
              ...buttonStyle,
              background: '#fff2f0',
              borderColor: '#ffccc7',
              color: '#ff4d4f',
              width: '50%',
              marginBottom: 0
            }}
            icon={<FontAwesomeIcon icon={faTimes} style={{ marginRight: 8 }} />}
            onClick={() => {
              if (handleCancel) {
                handleCancel()
              }
            }}
            disabled={scriptBusy || loading || printingScript}
          >
            Close
          </Button>
        )}

        {(isNew || isCopy || isEditMode) &&
          (isEditMode ? (
            <Button
              style={{
                ...buttonStyle,
                background: '#f6ffed',
                borderColor: '#389e0d',
                color: '#389e0d',
                width: '50%',
                marginBottom: 0
              }}
              icon={<FontAwesomeIcon icon={faCheck} style={{ marginRight: 8 }} />}
              onClick={() => handleSave()}
              loading={loading || printingScript || saving}
              disabled={
                scriptBusy ||
                script?.items?.length === 0 ||
                !script ||
                !script?.items ||
                (dischemDeliveryApplicable && (!dischemType || !selectedDischem))
              }
            >
              Save Changes
            </Button>
          ) : (
            <Popconfirm
              title='Finalise Script'
              description={
                script?.onSchedule && isNew
                  ? 'Are you sure? This will log the initial script date.'
                  : 'Are you sure? Scripts can`t be edited or deleted once created.'
              }
              onConfirm={() => {
                handleCreateScript(
                  script,
                  dischemDeliveryApplicable,
                  selectedDischem ? JSON.parse(selectedDischem).practiceNo : null,
                  dischemType,
                  dischemPaymentType
                )
              }}
              okText='Yes'
              cancelText='No'
              okButtonProps={{
                style: { background: token.colorSuccess }
              }}
              disabled={
                scriptBusy ||
                script?.items?.length === 0 ||
                !script ||
                !script?.items ||
                (dischemDeliveryApplicable && (!dischemType || !selectedDischem))
              }
            >
              <Button
                style={{
                  ...buttonStyle,
                  background: '#f6ffed',
                  borderColor: '#389e0d',
                  color: '#389e0d',
                  width: '50%',
                  marginBottom: 0
                }}
                icon={<FontAwesomeIcon icon={faCheck} style={{ marginRight: 8 }} />}
                loading={loading || printingScript || saving}
                disabled={
                  scriptBusy ||
                  script?.items?.length === 0 ||
                  !script ||
                  !script?.items ||
                  (dischemDeliveryApplicable && (!dischemType || !selectedDischem))
                }
              >
                Confirm
              </Button>
            </Popconfirm>
          ))}
      </div>

      <NurseScreeningMedicalHistory userRef={userRef} />
    </Space>
  )
}

export default SidePanel
